// export async function LoadCountData (searchString, userID) {

//     //-----LOAD TASKS FOR THE GRID -----//
//     //const [dataSource, setDataSource] = useState([]);
//     //const [taskAmount, setTaskAmount] = useState(0);

//     let dataSource = []
//     let taskAmount = 0;

//     const SearchString = searchString;
    
    
//     const newDataSource = (SearchString) => {
//       let string = SearchString;
//       if (string === '') {
//         string = 'EMPTY_SEARCH_STRING';
//       }
//       const url = `/returnStockCounts/${string}/${userID}`;
//       // console.log("url "+url)
//     //   const url = `/returnStockCounts/${userID}`;
//       return fetch(url)
//         .then((response) => response.json())
//         .then((data) => {
//           taskAmount = data.length;
//           return { data, count: data.length };
//         });
//     };
//       dataSource = newDataSource(SearchString);
    
//     //----------//

//     let returnValues = {
//       data: dataSource,
//       count: taskAmount
//     }
//     return returnValues;
// }

export async function LoadCountData(searchString, userID) {
  try {
    let string = searchString;
    if (string === '') {
      string = 'EMPTY_SEARCH_STRING';
    }
    const url = `/returnStockCounts/${string}/${userID}`;

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }

    const data = await response.json();
    const taskAmount = data.length;

    return { data, count: taskAmount };
  } catch (error) {
    throw error;
  }
}

